import { Link } from "@tanstack/react-router";
import { useAuth } from "../../auth/store";
import { useCan } from "../../auth/roles";
import { EmptyListMark, EmptyState } from "../../components/States";
import { PageHeader } from "../../components/ui";

/** Shown when the open page needs a plan that does not include it. */
export function CallUpgrade({ kind }: { kind: "diagnostics" | "analytics" }) {
  const auth = useAuth();
  const can = useCan();
  const analytics = kind === "analytics";
  return (
    <>
      <PageHeader title={analytics ? "Calls" : "Call"} />
      <div className="card">
        <EmptyState
          mark={<EmptyListMark />}
          title={analytics ? "Call analytics is on Business and Enterprise" : "Call diagnostics are on Team and above"}
          hint={
            analytics
              ? "Business and Enterprise include the Calls view, quality scores, and multi-party groups. Team includes call diagnostics on each replay."
              : "Team and above record loss, latency, freezes, and device errors on the replay. Audio and video from the call are never captured."
          }
          action={
            can.billing && auth.currentOrgId ? (
              <Link to="/orgs/$org/billing" params={{ org: auth.currentOrgId }} className="btn primary">
                See plans
              </Link>
            ) : undefined
          }
        />
      </div>
    </>
  );
}
